export default __webpack_public_path__ + "CircularCustCapNum-Light.cbf24aad51ef3e2c06db3f7e8605bd2d.eot";